export default __webpack_public_path__ + "static/media/noam_hof.79f1a242.png";